import React, { Component } from 'react';

import Navbar from "./Components/Navbar";

import './App.css'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";


// useEffect(() => { if (window.CobrowseIO)
//    { window.CobrowseIO.license = "1NUYm09MPdOujQ"; 
//    window.CobrowseIO.client().then(function () { 
//     window.CobrowseIO.start(); }); 
//   } }, []);

const Confdata = window['runConfig']
console.log("updated image");
class App extends Component {
  render() {
    return (
      <div className="App">
        <Router basename={Confdata?.jodobosaapp}>

          <Switch>
            <Route exact path="/" > <Navbar /> </Route>


          </Switch>

        </Router>
      </div>
    );
  }
}

export default App;


